/* global reactPress */
import axios from 'axios';
import WPAPI from 'wpapi';

// Initialize WPAPI
const wpOptions = process.env.NODE_ENV === 'development'
    ? {
        endpoint: reactPress.api.rest_url,
        username: process.env.REACT_APP_WP_USERNAME,
        password: process.env.REACT_APP_WP_PASSWORD,
    }
    : {
        endpoint: reactPress.api.rest_url,
        nonce: reactPress.api.nonce
    };

const wp = new WPAPI(wpOptions);

const REQUEST_TIMEOUT_MS = 30000;

export const getAccountID = async () => {
    try {
        const response = await axios.get(`${wp._options.endpoint}custom/v1/account`, {
            timeout: REQUEST_TIMEOUT_MS
        });
        if (!response.data) throw new Error("Empty response from Account ID endpoint");
        return response.data;
    } catch (error) {
        console.error('Failed to fetch Account ID:', error);
        throw error; // CRITICAL: Allows the UI to catch the failure
    }
};

export const getWebhookID = async (formName = {}) => {
    try {
        const param = new URLSearchParams(formName).toString();
        const response = await axios.get(`${wp._options.endpoint}custom/v1/getWebhookID?${param}`, {
            timeout: REQUEST_TIMEOUT_MS
        });
        if (!response.data) throw new Error(`Empty response from Webhook ID endpoint for ${formName}`);
        return response.data;
    } catch (error) {
        console.error('Failed to fetch Webhook ID:', error);
        throw error; // CRITICAL: Allows the UI to catch the failure
    }
};

export const getWPPosts = async (params = {}) => {
    try {
        const response = await axios.get(wp.posts().toString(), { params, timeout: REQUEST_TIMEOUT_MS });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getWPPostMedia = async (post) => {
    try {
        const response = await axios.get(`${wp.media()}/${post?.featured_media}`, {
            timeout: REQUEST_TIMEOUT_MS
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const postWP = async (rest_route, data) => {
    try {
        const response = await axios.post(`${wp._options.endpoint}${rest_route}`, data, {
            timeout: REQUEST_TIMEOUT_MS
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};